import { Component } from "@angular/core";
import { PurchaseFormService } from "./purchaseForm.service";
import { ToastsManager } from "ng2-toastr/ng2-toastr";
import { FormBuilder, Validators, FormGroup, FormControl } from "@angular/forms";
import { Constants } from "../constants/constants";
import { ActivatedRoute, Router } from "@angular/router";
import { FormStatus, FormType } from "../enums/enums";
import { PurchaseHistoryService } from "../purchaseHistory/purchaseHistory.service";

@Component({
    selector: "purchaseForm",
    templateUrl: "/app/purchaseForm/purchaseForm.template.html",
    providers: [PurchaseFormService, PurchaseHistoryService]
})
export class PurchaseFormComponent {
    purchaseForm = {} as IPurchaseFormModel;
    selectedDepartment: IDepartmentModel = null;
    selectedPurchaseType: IPurchaseTypeModel = null;
    selectedManager: IManagerModel = null;
    approvingManagers = [] as Array<IPurchaseFormManagerModel>;
    selectedApprovingManager: IPurchaseFormManagerModel = null;
    selectedShipMethod: IShipMethodModel = null;
    selectedCurrency: ICurrencyTypeModel = null;
    approvalAmount: number;
    managerEmail: string;
    itemToAdd = {} as IItemModal;
    items = [] as Array<IItemModal>;
    itemsFormGroup: FormGroup;
    purchaseFormGroup: FormGroup;
    capitalizeFormGroup: FormGroup;
    total = 0;
    approval = {} as IAppovalModel;
    attachments = [] as Array<File>;
    approvalId = 0;
    editPurchase: IAppovalModel;
    editRequiredDate: Date;
    currentDate = new Date().toLocaleString();
    ownsPurchase = false;
    submitting = false;
    currType: string;
    glCodeList = [] as Array<IGLCodeModel>;
    selectedGLCode: IGLCodeModel = null;
    selectedShippingLocation: ILocationModel = null;
    selectedPurchaseLocation: ILocationModel = null;
    loading: boolean = true;
    inValidGlCode: boolean = false;

    constructor(private purchaseFormService: PurchaseFormService, private toast: ToastsManager, private formBuilder: FormBuilder, private constants: Constants, private activatedRoute: ActivatedRoute, private purchaseHistoryService: PurchaseHistoryService, private router: Router) { }

    ngOnInit() {
        this.approvalId = this.activatedRoute.snapshot.params["approvalId"] ? this.activatedRoute.snapshot.params["approvalId"] : 0;
        this.approval.attachments = [];
        this.approval.productEndLocation = "";
        this.approval.items = [];
        this.approval.isBudgetExpense = -1;
        this.approval.isCapitalizeExpense = null;
        this.approval.shipLocation = "";
        this.buildValidationGroups();

        this.purchaseFormService.getPurchaseForm().subscribe((purchaseForm: IPurchaseFormModel): void => {
            if (purchaseForm) {
                this.purchaseForm = purchaseForm;

                if (this.approvalId > 0) {
                    this.purchaseHistoryService.getPurchaseById(this.approvalId).subscribe((purchase: IPurchaseHistoryModel): void => {
                        this.setupEdit(purchase);
                    });
                } else {
                    this.ownsPurchase = true;
                    this.approval.firstName = this.constants.user.firstName;
                    this.approval.lastName = this.constants.user.lastName;
                }
                this.loading = false;
            }
        });
    }

    onDateSelect() {
        document.getElementById('delivery-date').setAttribute('type','date');
        const todayDate = new Date().toISOString().split('T')[0];
        document.getElementById('delivery-date').setAttribute('min', todayDate);
    }

    setupEdit(purchase: IPurchaseHistoryModel) {
        this.ownsPurchase = purchase.username === this.constants.user.username;

        this.approval.id = purchase.id;
        this.approval.username = purchase.username;
        this.approval.attachments = purchase.attachments;
        this.approval.comment = purchase.comment;
        this.approval.managerComment = purchase.managerComment;
        this.approval.created = purchase.created;
        this.approval.firstName = purchase.firstName;
        this.approval.lastName = purchase.lastName;
        this.approval.formStatusId = purchase.formStatusId;
        this.approval.formTypeId = purchase.formTypeId;
        this.approval.items = purchase.items;
        this.approval.purchaserId = purchase.purchaserId;
        this.approval.title = purchase.title;
        this.approval.requiredDate = purchase.requiredDate.substring(0, 10);
        this.approval.shipMethodId = purchase.shipMethodId;
        this.approval.managerId = purchase.managerId;
        this.approval.isCapitalizeExpense = purchase.isCapitalizeExpense;
        this.approval.productEndLocation = purchase.productEndLocation;
        this.approval.currencyId = purchase.currencyId;
        this.approval.isBudgetExpense = purchase.isBudgetExpense;
        this.approval.requestors = purchase.requestors;
        this.approval.lifeTermMonths = purchase.lifeTermMonths;
        this.approval.shipLocation = purchase.shipLocation;
        this.approval.departmentId = purchase.departmentId;
        this.approval.purchaseLocationId = purchase.purchaseLocationId;
        this.approval.shippingLocationId = purchase.shippingLocationId;
        this.approval.glCode = purchase.glCode;

        purchase = this.removePurchaseItemPoNum(purchase);
        this.items = purchase.items;

        this.total = purchase.amount;
        this.selectedShipMethod = this.purchaseForm.shipMethods.find((shipMethod: IShipMethodModel) => shipMethod.id === purchase.shipMethodId);
        
        var dept = this.purchaseForm.departments.find((deparment: IDepartmentModel) => deparment.id === this.approval.departmentId);
        
        if (dept.isActive) {
            this.selectedDepartment = dept;
        } else {
            this.selectedDepartment = null;
        }
        this.selectedPurchaseType = this.purchaseForm.purchaseTypes.find((purchaseType: IPurchaseTypeModel) => purchaseType.id === purchase.purchaseTypeId);
        this.selectedCurrency = this.purchaseForm.currencyTypes.find((currencyType: ICurrencyTypeModel) => currencyType.id === purchase.currencyId);
        this.selectedPurchaseLocation = this.purchaseForm.locations.find((purchaseLocation: ILocationModel) => purchaseLocation.id === purchase.purchaseLocationId);
        this.selectedShippingLocation = this.purchaseForm.locations.find((shippingLocation: ILocationModel) => shippingLocation.id === purchase.shippingLocationId);
        
    }
    // Removes PoNumbers from the items in the purchase model and returns the purchase model object
    removePurchaseItemPoNum(purchase: IPurchaseHistoryModel): IPurchaseHistoryModel {
        //Checking To see if the purchase page we are navigating to is Completed or approved, if they are remove po numbers from items in this purchase
        // 5 = Completed Databse Side | Other ID's can be found under FormStatuses in db
        if (purchase.formStatusId == 5) {
            purchase.items.forEach(function (item) {
                item.poNumber = "";
            });
        }

        return purchase;
    }

    onDepartmentSelect(): void {
        if (!this.selectedDepartment)
            return;

        this.purchaseFormService.getPurchaseFormManagers(this.selectedDepartment.id, this.constants.user.email).subscribe((approvingManagers: Array<IPurchaseFormManagerModel>): void => {
            if (approvingManagers)
                this.approvingManagers = approvingManagers;

            this.selectedApprovingManager = null;
            this.approvalAmount = null;
            this.managerEmail = "";

            if (this.approvalId > 0)
                this.selectedApprovingManager = this.approvingManagers.find((manager: IPurchaseFormManagerModel) => manager.id === this.approval.managerId);
        });
    }

    lookUpForGlCode(query: string) {
        if (query.length > 3) {
            this.purchaseFormService.getGLCodeList(query.replace(/-/g, '')).subscribe((response: Array<IGLCodeModel>): void => {
                this.purchaseForm.glCodeList = [];
                this.purchaseForm.glCodeList = response;
                this.purchaseForm.glCodeList.forEach(item => { item.glAcctCode = this.purchaseFormService.formatGLCode(item.glAcctCode, [8, 2, 3, 2], '-'); });
            });
        }
    }

    onGlCodeChange() {
        this.approval.glCode = this.approval.glCode.replace(/-/g, "");
        if (this.approval.glCode.length > 0)
            this.approval.glCode = this.purchaseFormService.formatGLCode(this.approval.glCode, [8, 2, 3, 2], '-');
    }

    onApprovingManagerSelect() {
        if (!this.selectedApprovingManager)
            return;

        this.approvalAmount = this.selectedApprovingManager.amount;
        this.managerEmail = this.selectedApprovingManager.email;

        this.totalExceedsApprovalAmount();
    }

    onCurrencySelect() {
        if (!this.selectedCurrency)
            return;

        this.currType = this.selectedCurrency.currCode;
    }

    totalExceedsApprovalAmount(): void {
        if (this.total > this.approvalAmount)
            this.toast.warning("Your total dollar amount exceeds the amount the manager you have selected can approve.", "Please select another manager", { toastLife: 10000 });
    }

    addAttachments(input: HTMLInputElement): void {
        //input.value = "" is to ensure that you can add a file of the same name after you delete it. If you dont do this you will delete it and you cannot add it again until you add another file with a different name.
        if (input.files.length > 0) {

            for (let i = 0; i < input.files.length; i++) {
                let checkAttachment = this.approval.attachments.find((attachment: IAttachmentModal) => {
                    return attachment.name === input.files[i].name;
                });

                if (checkAttachment) {
                    this.toast.error("Cannot add a file that has the same name.", "Duplicate Filename", { toastLife: 10000 });
                    input.value = "";
                    return;
                }

                let attachmentToAdd = <IAttachmentModal>{
                    id: 0,
                    formId: this.approval.id,
                    formTypeId: FormType.Procurement,
                    name: input.files[i].name
                };

                this.approval.attachments.push(attachmentToAdd);
                this.attachments.push(input.files[i]);
            }

            input.value = "";
            this.toast.success("Attachment(s) added", "Success", { toastLife: 5000 });
        }
    }

    removeAttachment(attachment: IAttachmentModal): void {
        if (this.approval.attachments.length > 0) {

            if (attachment.id > 0) {
                this.purchaseFormService.removeAttachment(attachment).subscribe((deleted: boolean): void => {
                    if (deleted)
                        this.removeAttchmentFromApproval(attachment);
                });
            } else
                this.removeAttchmentFromApproval(attachment);
        }
    }

    removeAttchmentFromApproval(attachment: IAttachmentModal): void {
        let approvalIndex = this.approval.attachments.indexOf(attachment);

        if (approvalIndex > -1)
            this.approval.attachments.splice(approvalIndex, 1);

        let attach = this.attachments.find((file: File) => {
            return file.name === attachment.name;
        });

        let fileIndex = this.attachments.indexOf(attach);

        if (fileIndex > -1)
            this.attachments.splice(fileIndex, 1);

        this.toast.success("Attachment has been deleted.", "Delete Attachment", { toastLife: 10000 });
    }

    addItem(): void {
        if (!this.itemsFormGroup.valid)
            return;

        let item = <IItemModal>
            {
                approvalId: this.itemToAdd.approvalId,
                cost: this.itemToAdd.cost,
                description: this.itemToAdd.description,
                id: 0,
                poNumber: this.itemToAdd.poNumber,
                quantity: this.itemToAdd.quantity,
                suggestedSupplier: this.itemToAdd.suggestedSupplier,
                manufacturer: this.itemToAdd.manufacturer
            };

        this.items.push(item);
        this.total += (item.cost * item.quantity);

        this.totalExceedsApprovalAmount();

        this.itemToAdd.cost = null;
        this.itemToAdd.description = "";
        this.itemToAdd.poNumber = "";
        this.itemToAdd.quantity = null;
        this.itemToAdd.suggestedSupplier = "";
        this.itemToAdd.manufacturer = "";
    }

    removeItem(item: IItemModal): void {
        this.total -= (item.cost * item.quantity);
        this.items.splice(this.items.indexOf(item), 1);
    }

    buildValidationGroups(): void {
        this.itemsFormGroup = this.formBuilder.group({
            quantity: [1, [this.checkGreaterThanZero, Validators.required]],
            description: ["", [Validators.required]],
            cost: [0, [this.checkGreaterThanZero, Validators.required]],
            suggestedSupplier: "",
            poNumber: "",
            manufacturer: ""
        });

        this.capitalizeFormGroup = this.formBuilder.group({
            isCapitalizeExpense: null,
            productEndLocation: [""],
            lifeTermMonths: 0
        },
        {
            validator: this.isProductEndLocationFilled.bind(this)
        });

        this.purchaseFormGroup = this.formBuilder.group({
            title: ["", [Validators.required]],
            selectedDepartment: [null, [Validators.required]],
            selectedApprovingManager: [null, [Validators.required]],
            selectedPurchaseType: -1,
            selectedGLCode: null,
            selectedShippingLocation: [null, [Validators.required]],
            selectedPurchaseLocation: [null, [Validators.required]],
            managerEmail: "",
            requiredDate: [null, [Validators.required, this.validateDate]],
            approvalAmount: "",
            selectedShipMethod: [null, [Validators.required]],
            selectedCurrencyType: [null, [Validators.required]],
            isBudgetExpense: -1,
            requestors: "",
            shipLocation: ""
        },
        {
            validator: this.checkItems.bind(this)
        });
    }

    submitPurchaseForm(isSave: boolean): void {
        this.submitting = true;   
        this.loading = true;

        this.purchaseFormGroup.updateValueAndValidity();

        if (!this.purchaseFormGroup.valid)
            return;

        this.approval.departmentId = this.selectedDepartment.id;
        this.approval.formTypeId = FormType.Procurement;
        this.approval.managerId = this.selectedApprovingManager.id;
        this.approval.shipMethodId = this.selectedShipMethod.id;
        this.approval.items = this.items;
        this.approval.purchaseTypeId = 5; //this.selectedPurchaseType.id;
        this.approval.requiredDate = this.approval.requiredDate;
        this.approval.currencyId = this.selectedCurrency.id;
        this.approval.shippingLocationId = this.selectedShippingLocation.id;
        this.approval.purchaseLocationId = this.selectedPurchaseLocation.id;

        if (this.approval.isCapitalizeExpense == null) {
            this.approval.isCapitalizeExpense = false;
        }

        if (!this.approval.isCapitalizeExpense) {
            this.approval.productEndLocation = null;
        }

        if (this.approvalId > 0) {

            if (this.approval.formStatusId == FormStatus.Completed) {

                this.approval.username = this.constants.user.username;
                this.approval.lastName = this.constants.user.lastName;
                this.approval.firstName = this.constants.user.firstName;

                this.purchaseFormService.addPurchaseForm(this.approval).subscribe((result: IAppovalModel): void => {
                    if (result) {
                        this.purchaseFormService.copyAttachments(result.id, this.approvalId, this.approval.formTypeId).subscribe((copyAttachment: boolean): void => {
                            if (copyAttachment) {
                                this.processAddUpdate(result, isSave);
                            }
                            else {
                                this.toast.error("There was an error copying the attachments, but the req was added. Please reattach any files.", "Error", { toastLife: 10000 });
                                this.router.navigate(["history"]);
                            }
                        });
                    }
                    else {
                        this.toast.error("There was an error copying the requisition. Please contact support.", "Error", { toastLife: 10000 });
                    }
                    this.loading = false;
                });
            }
            else {

                this.approval.formStatusId = isSave ? FormStatus.Saved : FormStatus.WaitingManagerApproval;

                if (isSave) {
                    this.purchaseFormService.updatePurchaseForm(this.approval).subscribe((result: IAppovalModel): void => {
                        if (result)
                            this.processAddUpdate(result, isSave);
                    });
                } else {
                    if (this.approval.glCode) {
                        this.purchaseFormService.isGlCodeExist(this.approval.glCode.replace(/-/g,'')).subscribe((response: boolean): void => {
                            if (response) {
                                this.inValidGlCode = false;
                                this.purchaseFormService.updatePurchaseForm(this.approval).subscribe((result: IAppovalModel): void => {
                                    if (result)
                                        this.processAddUpdate(result, isSave);
                                });
                            } else {
                                this.inValidGlCode = true;
                                this.submitting = false;
                                this.loading = false;
                                return;
                            }
                        });
                    } else {
                        this.purchaseFormService.updatePurchaseForm(this.approval).subscribe((result: IAppovalModel): void => {
                            if (result)
                                this.processAddUpdate(result, isSave);
                        });
                    }
                }
            }
        } else {
            this.approval.username = this.constants.user.username;
            this.approval.lastName = this.constants.user.lastName;
            this.approval.firstName = this.constants.user.firstName;

            if (!isSave) {
                if (this.approval.glCode) {
                    this.purchaseFormService.isGlCodeExist(this.approval.glCode.replace(/-/g,'')).subscribe((response: boolean): void => {
                        if (response) {
                            this.inValidGlCode = false;
                            this.purchaseFormService.addPurchaseForm(this.approval).subscribe((result: IAppovalModel): void => {
                                if (result)
                                    this.processAddUpdate(result, isSave);
                            });
                        } else {
                            this.inValidGlCode = true;
                            this.submitting = false;
                            this.loading = false;
                            return;
                        }
                    });
                } else {
                    this.purchaseFormService.addPurchaseForm(this.approval).subscribe((result: IAppovalModel): void => {
                        if (result)
                            this.processAddUpdate(result, isSave);
                    });
                }

            } else {
                this.purchaseFormService.savePurchaseForm(this.approval).subscribe((result: IAppovalModel): void => {
                    if (result)
                        this.processAddUpdate(result, isSave);
                });
            }
        }
    }

    processAddUpdate(approval: IAppovalModel, isSave: boolean) {
        if (approval) {
            this.purchaseFormService.uploadAttachments(this.attachments, approval.id, approval.formTypeId).subscribe((attachmentResult: any): void => {
                if (attachmentResult) {
                    if (!isSave) {
                        this.toast.success("Purchase request has been accepted and is waiting manager approval.", "Success", { toastLife: 10000 });
                        this.router.navigate(["history"]);
                    } else {
                        this.toast.success("Purchase request has been saved.", "Success", { toastLife: 10000 });
                        this.router.navigate(["savedPurchases"]);
                    }
                } else
                    this.toast.error("There was an error adding your attachments. Please contact support.", "Error", { toastLife: 10000 });
            });
        }
        else
            this.toast.error("There was an error submitting your request. Please contact support.", "Error", { toastLife: 10000 });
    }

    getItemCost(cost: number, quantity: number): number {
        let total = cost * quantity;

        return isNaN(total) ? 0 : total;
    }

    checkGreaterThanZero(c: FormControl) {
        return !isNaN(c.value) && c.value > 0 ? null : { notValidNumber: { valid: false, message: "Please enter a number greater than zero" } };
    }

    checkItems = () => {
        return (this.items.length > 0 && this.total <= this.approvalAmount) ? null : { noItems: { valid: false, message: "No items added." } };
    }

    isProductEndLocationFilled = () => {
        var valid = true;
        if (this.total >= 1500) {
            if (this.approval.isCapitalizeExpense == true) {
                valid = (this.approval.productEndLocation && this.approval.productEndLocation.length !== 0)
            } else if (this.approval.isCapitalizeExpense == false) {
                valid = true;
            }
            else
                valid = false;
        }
        return valid ? null : { isCapitalizeExpenseRequired: { valid: false, message: "Product end location is required." } };
    }

    validateDate(c: FormControl) {
        let dateReg = /^\d{1,2}([./-])\d{1,2}\1\d{4}$/;
        let d = new Date(c.value);
        d.setMinutes(d.getMinutes() + d.getTimezoneOffset());
        let date = `${(d.getMonth() + 1)}/${d.getDate()}/${d.getFullYear()}`;
        let match = date.toString().match(dateReg);
        let currentutureDate = Date.parse(date) >= Date.parse(new Date().toDateString());

        return match && currentutureDate ? null : { notValidDate: { valid: false, message: "Invalid Date." } };
    }

    checkTotal() {
        this.total = 0;

        for (let i = 0; i < this.items.length; i++)
            this.total += this.items[i].quantity * this.items[i].cost;

        this.purchaseFormGroup.updateValueAndValidity();

        if (!this.purchaseFormGroup.valid)
            this.totalExceedsApprovalAmount();
    }

    isSubmitDisabled(): boolean {
        this.capitalizeFormGroup.updateValueAndValidity();
        var valid = this.purchaseFormGroup.valid && this.capitalizeFormGroup.valid && !this.submitting;

        return !valid;
    }
}